import { useTranslation } from "@redotech/redo-i18n";
import { SortState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SortDetails = memo(function SortDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<SortState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Destination")}
        </Text>
        <RedoTextInput
          placeholder={t("Sort destination")}
          setValue={(destination) =>
            setState((state) => ({ ...state, destination }))
          }
          value={state.destination}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
          {t(
            "Where the warehouse worker should route the unit (e.g. a bin label).",
          )}
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Next step (optional)")}
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
      </Flex>
    </Flex>
  );
});
